import { DataFetchWrapper, ErrorBox, Loader } from "@tfg/ui"
import { AxiosError } from "axios"

import { useFindOperationChainsQuery } from "~/pages/Admin/Ingestion/OpChains/hooks/useFindOperationChainsQuery"
import { useGetEcobalyseMaterialTypesQuery } from "~/pages/Admin/MasterLists/MaterialTypes/hooks/useGetEcobalyseMaterialTypesQuery"
import { useListMaterialTypesQuery } from "~/pages/Admin/MasterLists/MaterialTypes/hooks/useListMaterialTypesQuery"

import { MaterialTypesAdmin } from "./MaterialTypesAdmin"

export const MaterialTypesAdminWrapper = () => {
  const materialTypesQuery = useListMaterialTypesQuery()
  const {
    data: materialOpChains,
    isLoading,
    isError,
    error,
  } = useFindOperationChainsQuery({
    type: "MATERIAL",
    showDeleted: false,
  })
  const {
    data: ecobalyseMaterialTypes,
    isLoading: isEcobalyseTypesLoading,
    isError: isEcobalyseTypesError,
  } = useGetEcobalyseMaterialTypesQuery()

  if (isLoading || isEcobalyseTypesLoading) {
    return <Loader />
  }
  if (isError || isEcobalyseTypesError) {
    return <ErrorBox error={error as AxiosError} />
  }
  return (
    <>
      <DataFetchWrapper query={materialTypesQuery}>
        {({ data }) => (
          <MaterialTypesAdmin
            ecobalyseMaterialTypes={ecobalyseMaterialTypes}
            materialTypes={data}
            materialOpChains={materialOpChains.data}
          />
        )}
      </DataFetchWrapper>
    </>
  )
}
